import { Collapse } from 'antd';
import React, { Component } from 'react'
import { Card } from 'reactstrap';
import CardRender from './CardRender';
import ChartRender from './ChartRender';
import {
    DeleteOutlined
} from '@ant-design/icons';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import SettingsService from '../../services/api/Setting';
import { APIRESPONSE } from '../../settings/shared/constants';
import { toast } from 'react-toastify';
import PowerBiRender from './PowerBiRender';
import TableRender from './TableRender';


const { Panel } = Collapse;

class WidgetsDataRender extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setFinalData: []
        }
    }

    componentDidMount() {

    }

    _getLayoutData = (widgetId, widgetData) => {
        let updateIndex = this.state.setFinalData.findIndex(item => item.widgetId === widgetId);
        if (updateIndex !== -1) {
            this.state.setFinalData[updateIndex] = widgetData;
            this.setState({ setFinalData: this.state.setFinalData }, () => {
                this.props._publishLayout(widgetId, [this.state.setFinalData[this.state.setFinalData.length -1]])
            });
        } else {
            this.setState({
                setFinalData: [...this.state.setFinalData, widgetData]
            }, () => {
                this.props._publishLayout(widgetId, [this.state.setFinalData[this.state.setFinalData.length -1]])
            })
        }
    }

    onRemoveWidgetsConfirmation = (idx, type) => {
        confirmAlert({
            title: 'Remove Widget',
            message: 'Are you sure to remove this widget -' + type + '?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: e => this.RemoveWidgets(idx)
                },
                {
                    label: 'No',
                    onClick: () => {
                    }
                }
            ]
        });
    };

    RemoveWidgets = (idx) => {
        if(idx !== null && idx !== undefined){
            SettingsService.removeWidgetById(idx).then((response) =>{
                if (response.status === APIRESPONSE.SUCCESS) {
                    toast.success(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Widget Removed Successfully</b></i>);
                    this.props._removeWidget();  // here reload the widgets
                } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
                }
            })
        }
    }

    render() {
        return (
            <Card className='shadow-none'>
                {this.props.widgetsList.map((item, index) => (
                    <Collapse accordion bordered={true} key={index}>
                        <Panel header={index + 1 + " - " + item.widgetType} key={index} extra={ item.widgetType === "Custom" && <DeleteOutlined className='hover-delete' onClick={event => {
                            event.stopPropagation();
                            this.onRemoveWidgetsConfirmation(item.id, item.widgetType)
                        }} />}>
                            <code><span className='pl-1 font16 font-weight-bold'>Widget Type - {item.widgetType}</span></code>
                            {item.widgetType === "Card" && <CardRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Bar" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Pie" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Column" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Doughnut" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Line" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Spline" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Area" && <ChartRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "PowerBI" && <PowerBiRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} />}
                            {item.widgetType === "Table" && <TableRender widgetIndex={index}  widgetId = {item.id} widgetItem = {item} _getLayoutData={this._getLayoutData.bind(this)} widgetType={item.widgetType} /> }
                        </Panel>
                    </Collapse>
                ))}
                {this.props.widgetsList !== null && this.props.widgetsList.length === 0 && <Card className='text-center p-3'>
                    <span className='font14'>No Widgets Selected</span></Card>}
            </Card>
        );
    }
}

export default WidgetsDataRender;
